import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const featureImages = [
  {
    id: 'dailysai',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20performance%20with%20vibrant%20hot%20pink%20spotlights%2C%20music%20festival%20energy%2C%20crowd%20excitement%2C%20dramatic%20lighting%2C%20entertainment%20industry%20vibe%2C%20editorial%20photography&width=800&height=600&seq=feature-grid-dailysai&orientation=landscape',
    large: true,
  },
  {
    id: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20flash%20photography%2C%20glamorous%20atmosphere%2C%20celebrity%20culture%20scene%2C%20luxury%20fashion%20vibe%2C%20paparazzi%20moment%2C%20editorial%20style&width=800&height=500&seq=feature-grid-celebrity&orientation=landscape',
    large: false,
  },
  {
    id: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20studio%20setup%20with%20ring%20light%20and%20camera%2C%20modern%20content%20creation%20space%2C%20trendy%20aesthetic%2C%20digital%20creator%20lifestyle%2C%20editorial%20photography&width=800&height=500&seq=feature-grid-influencer&orientation=landscape',
    large: false,
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
              核心频道
            </h2>
            <p className="mt-2 text-sm text-foreground-500">六大栏目 · 全面覆盖娱乐圈每一个角落</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureImages.map((fi) => {
            const cat = categories.find(c => c.id === fi.id);
            if (!cat) return null;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group block rounded-2xl bg-background-100 hover:bg-background-100/80 transition-colors duration-300 overflow-hidden cursor-pointer ${
                  fi.large ? 'md:col-span-1 md:row-span-2' : ''
                }`}
              >
                <div className={`${fi.large ? 'aspect-[4/3]' : 'aspect-[16/10]'} relative overflow-hidden`}>
                  <img
                    src={fi.imageUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  {fi.large && (
                    <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                      最热频道
                    </span>
                  )}
                </div>
                <div className={`p-5 ${fi.large ? 'md:p-6' : ''}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    <h3 className={`font-heading font-bold text-foreground-950 ${fi.large ? 'text-xl' : 'text-lg'}`}>
                      {cat.name}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">{cat.description}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 mt-5">
          {categories.slice(3).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-3 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div>
                <h4 className="text-sm font-bold text-foreground-950">{cat.name}</h4>
                <p className="text-xs text-foreground-500">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}